export let benchmark = [[
    [43, 32],
    [12, 12],
    [33,23]

], [
    [43, 32, 56, 24],

], [
    [43, 32, 56,13,24],

], [
    [43, 32, 56,33,5,23,10,15,18,67,11,24,41,29,33],[76]

], [
    [43, 32, 56,33,23,10,15,18,11],[76]
    
    

], [
    [43, 32, 56,32,],
    [12, 32, 32,23,],
    [12,32,23,10, ],
    [32,23,10,12,],
    [24,36,47,15],
    [18,26,36,45]

], [
    [43, 32, 56,22,12,31],
    

], [
    [43, 32, 56,24,36,],
    [12, 32,24,36,47,],
    [24,36,10, 32, 22],
    [24,36,47,10, 32],
    [24,10, 32, 22,36],
    [32, 56,32,23,10],
    [32,23,10,12, 32]

], [
    43, 32

], [
    43, 32, 56

]]